import React, { useState } from "react";
import { useWatchState, handler } from "@/store";
import { Wave } from "@/components";
import { createSelectOption } from "@/common";
import { BaseService, RemindService, UserService } from "@/service";
import moment from "moment";
import { Modal, Button, Form, Input, message, Icon, Select } from "antd";
import "./style.less";

const InputGroup = Input.Group;
const { Option } = Select;

const App = () => {

    const [loading, setLoading] = useState(false);
    const [name, setName] = useState(undefined);
    const [sex, setSex] = useState(undefined);
    const [orgName, setOrgName] = useState(undefined);
    const [post, setPost] = useState(undefined);
    const [phone, setPhone] = useState(undefined);
    const [trafficType, setTrafficType] = useState(undefined);
    const [[{ title, show, hide, width = 300, courseId, courseName }]] = useWatchState(["modal.courseSignUp"])

    const onSign = async () => {
        if (!name) return message.warn("请输入姓名！");
        if (!phone) return message.warn("请输入电话！");
        setLoading(true)
        // 先判断是否已经报过名了
        const res = await BaseService.list({
            table: "thtt_course_user",
            where: {
                course_id: courseId, name, phone, is_delete: 0
            }
        })
        if (res.data.result.length) return message.warn("您已经报过名啦！")

        const addRes = await BaseService.add({
            table: "thtt_course_user",
            data: { course_id: courseId, name, sex, org_name: orgName, post, phone, traffic_type: trafficType, add_time: new Date().format("yyyy-MM-dd hh:mm:ss"), is_delete: 0 }
        });
        setLoading(false)
        if (addRes.data.status !== 200) {
            message.error(addRes.data.msg);
            return;
        }
        message.success("报名成功");
        hide();
    }

    return (
        <Modal
            className="modal-courseSignUp"
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            onCancel={hide}
            footer={false}
        >
            <div className="modal-courseSignUp__body child-top-sm p-md-lr">
                <p className="font-size-14 child-left-sm"><span className="dark-disable">您即将报名</span><span>{courseName}</span></p>
                <InputGroup compact>
                    <Input style={{ width: '70%' }} placeholder="请输入您的姓名" onChange={e => setName(e.target.value)} />
                    <Select style={{ width: '30%' }} defaultValue="0" onChange={e => setSex(e)}>
                        <Option value="0">男</Option>
                        <Option value="1">女</Option>
                    </Select>
                </InputGroup>
                <Input placeholder="请输入您的单位" onChange={e => setOrgName(e.target.value)} />
                <Input placeholder="请输入您的职务"  onChange={e => setPost(e.target.value)}/>
                <Input placeholder="请输入您的电话" onChange={e => setPhone(e.target.value)} />
                <Select onChange={e => setTrafficType(e)} style={{ width: '100%' }} placeholder="请选择交通方式" defaultValue="0">
                    <Option value="0">自驾</Option>
                    <Option value="1">地铁</Option>
                </Select>
                <div className="modal-courseSignUp__btn child-left-sm flex">
                    <Button type="default" onClick={hide}>取消</Button>
                    <Button className="full" onClick={onSign}>预约报名</Button>
                </div>
            </div>
        </Modal>
    );
}

export default App;